<div class="container animated fadeIn fast">
    <div class="row mt-3">
        <div class="col-lg-8" >

          <mat-card>
            <mat-card-title>
              Paciente
            </mat-card-title>
            <mat-card-content>
              <div class="form-row">
                <mat-form-field class="col-md-6">
                  <mat-label>Nombre</mat-label>
                  <input matInput placeholder="" [(ngModel)]="filter.name" name="name">
                </mat-form-field>
                <mat-form-field class="col-md-6">
                  <mat-label>Apellido</mat-label>
                  <input matInput placeholder="" [(ngModel)]="filter.surname" name="surname">
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="col-md-4">
                  <mat-label>DNI</mat-label>
                  <input matInput placeholder="" [(ngModel)]="filter.dni" name="dni">
                </mat-form-field>
                <mat-form-field class="col-md-4">
                  <mat-label>Servicio</mat-label>
                  <mat-select  [(ngModel)]="filter.wards">
                    <mat-option *ngFor="let ward of wards" value="{{ward.id}}">
                      {{ward.wardDescription}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="col-md-4">
                  <mat-label>Estado</mat-label>
                  <mat-select  [(ngModel)]="filter.orderState">
                    <mat-option *ngFor="let state of status" value="{{state.value}}">
                      {{state.text}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>
            <!--<div class="card">
                <div class="card-header">
                    Paciente
                </div>
                <div class="card-body">
                        <div class="form-row">
                          <div class="form-group col-md-6">
                            <label for="inputEmail4">Nombre</label>
                            <input type="email" class="form-control" [(ngModel)]="filter.name" name="name">
                          </div>
                          <div class="form-group col-md-6">
                            <label for="inputPassword4">Apellido</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.surname" name="surname">
                          </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-4">
                              <label for="inputEmail4">DNI</label>
                              <input type="number" class="form-control" [(ngModel)]="filter.dni" name="dni">
                            </div>
                            <div class="form-group col-md-4">
                              <label for="inputPassword4">Servicio</label>
                              <select class="form-control" [(ngModel)]="filter.ward" name="nhc">
                                <option *ngFor="let ward of wards" value="{{ward.id}}">{{ward.wardDescription}}</option>
                                </select>
                            </div>
                            <div class="form-group col-md-4">
                                <label for="inputPassword4">Estado</label>
                                <select class="form-control" [(ngModel)]="filter.state" name="nhc">
                                  <option *ngFor="let state of status" value="{{state.value}}">{{state.text}}</option>
                                  </select>
                              </div>
                        </div>
                </div>
            </div>-->

        </div>
        <div class="col-lg-4">
          <mat-card>
            <mat-card-title>
              Solicitud
            </mat-card-title>
            <mat-card-content>
              <mat-form-field class="w-100">
                <mat-label>Informe</mat-label>
                <input matInput placeholder="" [(ngModel)]="filter.orderId" name="orderId">
              </mat-form-field>
              <div class="row">
                <mat-form-field class="col-md-6">
                  <mat-label>Desde</mat-label>
                  <input matInput [matDatepicker]="picker" name="startDate" [(ngModel)]="filter.startDate">
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <mat-form-field class="col-md-6">
                  <mat-label>Hasta</mat-label>
                  <input matInput [matDatepicker]="picker2" name="endDate" [(ngModel)]="filter.endDate">
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                </mat-form-field>
              </div>
            </mat-card-content>
          </mat-card>

            <!--<div class="card">
                <div class="card-header">
                    Informe
                </div>
                <div class="card-body">
                    <form>
                        <div class="form-group">
                          <label for="inputAddress">Informe</label>
                          <input type="number" class="form-control" [(ngModel)]="filter.orderid" name="inputAddress">
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                              <label for="inputEmail4">Desde</label>
                              <div class="input-group">
                                <input class="form-control" placeholder="yyyy-mm-dd"
                                       name="startDate" [(ngModel)]="filter.startDate" ngbDatepicker #start="ngbDatepicker">
                                <div class="input-group-append">
                                  <button class="btn btn-outline-secondary calendar" (click)="start.toggle()" type="button"><fa-icon [icon]="faCalendar"></fa-icon></button>
                                </div>
                              </div>
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputEmail4">Hasta</label>
                                <div class="input-group">
                                  <input class="form-control" placeholder="yyyy-mm-dd"
                                         name="endDate" [(ngModel)]="filter.endDate" ngbDatepicker #end="ngbDatepicker">
                                  <div class="input-group-append">
                                    <button class="btn btn-outline-secondary calendar" (click)="end.toggle()" type="button"><fa-icon [icon]="faCalendar"></fa-icon>
                                    </button>
                                  </div>
                                </div>
                            </div>
                          </div>
                      </form>
                </div>
            </div>-->
        </div>
    </div>

        <div class="col-lg-12 text-center mt-3">
          <button mat-raised-button color="primary" (click)="search()" > Buscar </button>
          <button mat-flat-button (click)="clean()" > Limpiar </button>
        </div>

        <mat-card [hidden]="!newData">
          <mat-card-title>
            Resultados
          </mat-card-title>
          <mat-card-content>
            <table mat-table [dataSource]="dataSource" matSort class = "w-100">
            <!-- Number Column -->
            <ng-container matColumnDef="number">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
              <td mat-cell *matCellDef="let order">{{ order.orderId }}</td>
            </ng-container>

            <!-- Title Column -->
            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Fecha</th>
              <td mat-cell *matCellDef="let order">{{order.orderDate}}</td>
            </ng-container>

            <!-- State Column -->
            <ng-container matColumnDef="patient">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Paciente</th>
              <td mat-cell *matCellDef="let order">{{ order.patientName + " ("+order.patientSex+")" }}</td>
            </ng-container>

             <!-- State Column -->
            <ng-container matColumnDef="service">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Servicio</th>
              <td mat-cell *matCellDef="let order">{{ order.ward.wardDescription }}</td>
            </ng-container>

             <!-- State Column -->
            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Acciones</th>
              <td mat-cell *matCellDef="let order">
                <button mat-icon-button *ngIf="order.lastReportId != -1 && order.lastReportId != null" (click)="viewReport(order, content); $event.stopPropagation()">
                  <mat-icon aria-hidden="false" aria-label="Example home icon">print</mat-icon>
                </button>
                <button mat-icon-button (click)="viewResults(order, result); $event.stopPropagation()">
                  <mat-icon aria-hidden="false" aria-label="Example home icon">visibility</mat-icon>
                </button>
                <button mat-icon-button *ngIf="order.orderState.value == -1" (click)="deleteOrder(order); $event.stopPropagation()" type="button">
                  <mat-icon aria-hidden="false" aria-label="Example home icon">close</mat-icon>
                </button>
                <a mat-icon-button *ngIf="order.orderState.value == -1" href="order-entry/edit-order/{{order.ward.wardId}}/{{order.orderId}}" type="button">
                  <mat-icon aria-hidden="false" aria-label="Example home icon">create</mat-icon>
                </a>




              </td>
            </ng-container>


            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let order; columns: displayedColumns;" (click)="selectOrder(order, order.index)" [class.selected] = "order.selected"></tr>
          </table>
          <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons></mat-paginator>

          <button  mat-raised-button color="primary" (click)="viewReports(content)">Informe</button>

          </mat-card-content>
        </mat-card>

        <!--<div class="card mt-3" *ngIf="newData">
          <div class="card-header">Resultados</div>
          <div class="card-body">
            <table class="table table-striped">
              <thead>
              <tr>
                <th scope="col"></th>
                <th scope="col">ID</th>
                <th scope="col">Fecha</th>
                <th scope="col">Paciente</th>
                <th scope="col">Servicio</th>
                <th scope="col">Estado</th>
                <th scope="col">Acciones</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let order of orders" (click)="selectOrder(order, order.index)" [class.seleceted] = "order.selected">
                <th scope="row">{{ order.selected ? "x":"" }}</th>
                <td>{{ order.orderId }}</td>
                <td>{{ order.orderDate }}</td>
                <td>{{ order.patientName + "("+order.patientSex+")" }}</td>
                <td>{{ order.ward.wardDescription }}</td>
                <td>{{ order.orderState.description }}</td>
                <td>
                  <button *ngIf="order.lastReportId != -1 && order.lastReportId != null" class="btn btn-outline-secondary calendar" (click)="viewReport(order, content)" type="button"><fa-icon [icon]="faPdf"></fa-icon></button>
                  <button *ngIf="order.orderState.value >= 5" class="btn btn-outline-secondary calendar" (click)="viewResults(order, result)" type="button"><fa-icon [icon]="faEye"></fa-icon></button>
                  <a *ngIf="order.source == -1" class="btn btn-outline-secondary calendar" title="Editar solicitud" [routerLink]="['/order-entry/edit-order', order.ward.wardId, order.orderId]" type="button"><fa-icon [icon]="faPencil"></fa-icon></a>
                  <button *ngIf="order.orderState.value == -1" class="btn btn-outline-secondary calendar" (click)="deleteOrder(order)" type="button"><fa-icon [icon]="faTrash"></fa-icon></button>
                </td>
              </tr>
              </tbody>
            </table>


            <div class="d-flex justify-content-between p-2">
              <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="pageSize">
              </ngb-pagination>

              <select class="custom-select" style="width: auto" [(ngModel)]="pageSize">
                <option [ngValue]="10">10 por pág.</option>
                <option [ngValue]="20">20 por pág.</option>
                <option [ngValue]="50">50 por pág.</option>
              </select>
            </div>
            <button (click)="viewReports()"  class="btn btn-primary btn-lg" tabindex="-1" role="button" aria-disabled="true">Informe</button>


          </div>
        </div>-->


</div>


<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
      <!-- <h4 class="modal-title" id="modal-basic-title">Hi there!</h4> -->
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <iframe [src] = "pdf" style="width: 100%; height: 70vh;"></iframe>
    </div>
  </ng-template>

  <ng-template #result let-c="close" let-d="dismiss">
    <div class="modal-header">
      <!-- <h4 class="modal-title" id="modal-basic-title">Hi there!</h4> -->
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <table class="table table-striped">
        <thead>
        <tr>
          <th scope="col">Examen</th>
          <th scope="col">Resultado</th>
          <th scope="col">U.M.</th>
          <th scope="col">V.Ref.</th>
          <th scope="col">Validado por</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let result of results">
          <th *ngIf="result.isBold" scope="row">{{ result.testDescription }}</th>
          <td *ngIf="!result.isBold" >{{ result.testDescription }}</td>
          <td>{{ result.result || result.note }}</td>
          <td>{{ result.measureUnit }}</td>
          <td>{{ result.referenceValues }}</td>
          <td>{{ result.validationUser }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </ng-template>
